import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import styles from '../../../styles/Componentes/EulaDrawer.module.css';

const EulaDrawer = ({ isOpen, onClose, content, loading }) => {
  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    if (isOpen) document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return (
    <>
      <div
        className={`${styles.overlay} ${isOpen ? styles.visible : ''}`}
        onClick={onClose}
      />

      <div className={`${styles.drawer} ${isOpen ? styles.open : ''}`}>
        <div className={styles.header}>
          <h2>Políticas de privacidad (EULA)</h2>
          <button className={styles.closeBtn} onClick={onClose} aria-label="Cerrar">
            <X size={20} />
          </button>
        </div>

        <div className={styles.body}>
          {loading ? (
            <div className={styles.loading}>
              <span className={styles.spinner} />
              <p>Cargando políticas...</p>
            </div>
          ) : (
            <div className={styles.content}>
              {content ? (
                <div className={styles.eulaText} dangerouslySetInnerHTML={{ __html: content }} />
              ) : (
                <p className={styles.empty}>No hay contenido disponible.</p>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EulaDrawer;